import { render } from "./External.vue?vue&type=template&id=02029287&scoped=true"
import script from "./External.vue?vue&type=script&lang=js"
export * from "./External.vue?vue&type=script&lang=js"

import "./External.vue?vue&type=style&index=0&id=02029287&lang=scss&scoped=true"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/cdas-intranet-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02029287"]])

export default __exports__